export default __webpack_public_path__ + "static/media/mapa.93b4134d.png";